import { useEffect, useState } from "react";
import { Environment } from "../config/environment";

declare global {
    interface Window {
        google: any;
        initGoogleMaps: () => void;
    }
}

export const useGoogleMaps = () => {
    const [isLoaded, setIsLoaded] = useState(false);
    const [loadError, setLoadError] = useState<string | null>(null);

    useEffect(() => {
        if (window.google && window.google.maps && window.google.maps.places) {
            setIsLoaded(true);
            return;
        }

        if (document.querySelector('script[src*="maps.googleapis.com"]')) {
            const checkGoogle = setInterval(() => {
                if (window.google && window.google.maps && window.google.maps.places) {
                    setIsLoaded(true);
                    clearInterval(checkGoogle);
                }
            }, 100);
            return () => clearInterval(checkGoogle);
        }

        const apiKey = Environment.GOOGLE_PLACES_API;
        if (!apiKey) {
            setLoadError("Chave da API do Google Places não configurada");
            return;
        }

        const script = document.createElement("script");
        script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places&language=pt-BR`;
        script.async = true;
        script.defer = true;
        
        script.onload = () => {
            setIsLoaded(true);
        };

        script.onerror = () => {
            setLoadError("Erro ao carregar o script do Google Maps");
        };

        document.head.appendChild(script);

        return () => {
            const existingScript = document.querySelector(`script[src*="${apiKey}"]`);
            if (existingScript) {
                existingScript.remove();
            }
        };
    }, []);

    return { isLoaded, loadError };
};

